import api from '../api';

import { ParamsBodyGerarCobranca, ParamsDataGerarCobranca } from 'utils/typeServices';

type ParamsResponse = {
    Data: ParamsDataGerarCobranca;
}

export const PostGerarCobranca = async ({ token, body }: { token: string, body: ParamsBodyGerarCobranca }) => {
    const bodyJson = JSON.stringify({
        CARTAO_CREDITO: {
            CODIGO_SEGURANCA: body.CARTAO_CREDITO.CODIGO_SEGURANCA,
            NM_NOME: body.CARTAO_CREDITO.NM_NOME,
            NR_ANO_VALIDADE: body.CARTAO_CREDITO.NR_ANO_VALIDADE,
            NR_MES_VALIDADE: body.CARTAO_CREDITO.NR_MES_VALIDADE,
            NR_NUMERO: body.CARTAO_CREDITO.NR_NUMERO,
            NR_PARCELAS: body.CARTAO_CREDITO.NR_PARCELAS
        },
        CD_FORMA_PAGAMENTO: body.CD_FORMA_PAGAMENTO,
        CHAVE_PAGAMENTO: body.CHAVE_PAGAMENTO,
        EMAIL: body.EMAIL,
        validade_cartao: body.validade_cartao
    });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Pagamento/GerarCobranca', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (data.Data.codigo < 0) {
            return { data: null };
        }
        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}